import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { take, tap } from 'rxjs';
import { SnackbarPanelClass } from '../models/snackbar-panel-config';

@Injectable({
  providedIn: 'root',
})
export class SnackbarWithNavService {
  private snackBar = inject(MatSnackBar);
  private router = inject(Router);

  show(message: string, route: string, panelClass: SnackbarPanelClass): void {
    this.snackBar.open(message, '', {
      duration: 2000,
      panelClass: panelClass
    }).afterDismissed().pipe(
      take(1),
      tap(() => this.router.navigate([route]))
    ).subscribe();
  }
}
